import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { MenuItem, ListItemText, Button, Popover, Box, InputLabel, FormControl } from '@mui/material';
import _ from 'lodash';
import { MultiSelectBoxButton } from 'theme/elements/Buttons';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';

export type SelectedList = { name: string; value: string }[];

type selectorProps = {
	options: SelectedList;
	primaryOption?: string;
	label?: string;
	handleChange?: (list: SelectedList) => void;
	primaryLabel?: string;
};

export default function MultipleSelectCheckmarks(props: selectorProps) {
	const [selected, setSelected] = React.useState<{ name: string; value: string }[]>([]);
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const optionValues = props.options.map((o) => o.value).join(',');
	React.useEffect(() => {
		if (selected.length === 0) return;
		const validValues = new Set(props.options.map((o) => o.value));
		const filtered = selected.filter((s) => validValues.has(s.value));
		if (filtered.length !== selected.length) {
			setSelected(filtered);
			if (props.handleChange) {
				const final = props.options.length === filtered.length ? [] : filtered;
				props.handleChange(final);
			}
		}
	}, [optionValues]);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const checked = event.target.checked;
		const name = event.target.name;
		const option = { name: name, value: event.target.value };
		let selecting: SelectedList = [];

		if (name === 'all') {
			selecting = !checked ? [] : props.options;
		} else {
			selecting = checked ? [...selected, option] : _.filter(selected, (option) => option.name !== name);
		}
		setSelected(selecting);
		if (props.handleChange) {
			const final = props.options.length === selecting.length ? [] : selecting;
			props.handleChange(final);
		}
	};
	const isAllSelected = props.options.length > 0 && selected.length === props.options.length;

	return (
		<FormControl
			sx={{
				width: 'fit-content',
				'& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
					//border: `1px solid ${theme.palette.root.inputFocusGreen}`,
				},
				'& label': {
					transform: 'translate(9px, -9px) scale(0.75)',
					background: '#fff',
					padding: '0 3px',
				},
			}}
		>
			<InputLabel id="simple-select-label">{props.label}</InputLabel>
			<MultiSelectBoxButton>
				<Button
					className={selected.length > 0 && !isAllSelected ? 'selectedItems' : ''}
					aria-describedby={id}
					variant="contained"
					onClick={handleClick}
					endIcon={<ArrowDropDown />}
				>
					{isAllSelected || selected.length === 0
						? props.primaryLabel || 'Select All'
						: selected.length + ' ' + props.label}
				</Button>
			</MultiSelectBoxButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<MenuItem value="all">
					<Checkbox
						name="all"
						onChange={handleChange}
						checked={isAllSelected}
						indeterminate={selected.length > 0 && selected.length < props.options.length}
					/>
					<ListItemText primary={props.primaryLabel || 'Select All'} />
				</MenuItem>
				{props.options.map((option) => (
					<MenuItem key={option.name} value={option.value}>
						<Checkbox
							name={option.name}
							value={option.value}
							onChange={handleChange}
							checked={!_.isEmpty(_.find(selected, option))}
						/>
						<ListItemText primary={option.name} />
					</MenuItem>
				))}
			</Popover>
		</FormControl>
	);
}
